module.exports = __webpack_public_path__ + "static/img/zgyd.b39588b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zgyd.png
// module id = zJ9Z
// module chunks = 4